import { useEffect, useState } from "react";
import NavBar from "../../components/navbar/NavBar";
import styles from "./AdminOverview.module.scss";
import axios from "axios";
import { saveMe } from "../../redux/actions/me/meActions";
import { useDispatch } from "react-redux";
import { Grid } from "@mui/material";
import { openToastAndSetContent } from "../../redux/actions/toast/toastActions";
import BarTopFilterDate from "../../components/barTopFilterDate/BarTopFilterDate";
import TotalIcon from "../../assets/images/total-transactions.svg";
import ReportIcon from "../../assets/images/reports.svg";
import FailedIcon from "../../assets/images/failed.svg";
import PendingIcon from "../../assets/images/pending.svg";
import {
	dateIT,
	sevenDaysAgo,
	thirtyDaysAgo,
	startOfYear,
	endOfYear,
} from "../../util/DateUtil";
import useCalender from "../../hooks/useCalender";
import { numberWithCommas } from "../../util/formatNumber";
import {
	closeLoader,
	openLoader,
} from "../../redux/actions/loader/loaderActions";
import OverviewTable from "../../components/OverviewTable/OverviewTable";
import DashboardProductTable from "../../components/dashboardProductTable/DashboardProductTable";
// import PieChart from "../../components/pieChart/PieChart";
import SimpleBarChart from "../../components/simpleBarChart/SimpleBarChart";
import PolarAreaChart from "../../components/polarAreaChart/PolarAreaChart";
import TransactionBarChart from "../../components/TransactionsBarChart/TransactionsBarChart";
import ChargeBackChart from "../../components/chargeBackChart/ChargeBackChart";
import OverviewFailureTable from "../../components/OverviewFailureTable/OverviewFailureTable";

interface infoTypes {
	currency: string;
	total: number;
	total_count: number;
	success: number;
	success_count: number;
	failed: number;
	failed_count: number;
	pending: number;
	pending_count: number;
}

interface businessType {
	tradingname: string;
	merchantcode: string;
	currency: string;
	transaction_amount: string;
	transaction_count: string;
}

interface failureType {
	responsecode: string;
	count: number;
}
interface currencyType {
	currency: string;
	data: {
		date: string;
		currency?: string;
		total?: number;
		success?: number;
		failed?: number;
		pending?: number;
	}[];
}
interface countryType {
	country: string;
	total: number;
}

interface transactionType {
	date: string;
	total: number;
	success: number;
	failed: number;
	pending: number;
}

const AdminOverview = () => {
	const dispatch = useDispatch();
	const [info, setInfo] = useState<infoTypes>();
	const [selectedInfo, setSelectedInfo] = useState({});
	const [topBusiness, setTopBusiness] = useState<businessType[]>([]);
	const [topFailure, setTopFailure] = useState<failureType[]>([]);
	const [topCurrency, setTopCurrency] = useState<currencyType[]>([]);
	const [topCountry, setTopCountry] = useState<countryType[]>([]);
	const [currencyDetails, setCurrencyDetails] = useState<any[]>([]);
	const [topTransaction, setTopTransaction] = useState<transactionType[]>([]);
	const [topCardType, setTopCardType] = useState<any>([]);
	const [topChargeType, setTopChargeType] = useState<any>([]);
	const [topChargeBack, setTopChargeBack] = useState<any>([]);
	const { calender, setCalender } = useCalender();
	const [dateEvent, setDateEvent] = useState<string>("today");
	const [startDate, setStartDate] = useState(dateIT);
	const [endDate, setEndDate] = useState(dateIT);
	const [currency, setCurrency] = useState("NGN");

	const [payout, setPayout] = useState<any>();

	const [loading, setLoading] = useState<boolean>(false);

	useEffect(() => {
		axios
			.get(`/v1/profile/me`)
			.then((res) => {
				dispatch(saveMe(res.data));
			})
			.catch((err) => console.log(err));
	}, [dispatch]);

	useEffect(() => {
		if (dateEvent === "today") {
			setStartDate(dateIT);
			setEndDate(dateIT);
			setCalender([dateIT, dateIT]);
		} else if (dateEvent === "last7days") {
			setStartDate(sevenDaysAgo);
			setEndDate(dateIT);
			setCalender([sevenDaysAgo, dateIT]);
		} else if (dateEvent === "last30days") {
			setStartDate(thirtyDaysAgo);
			setEndDate(dateIT);
			setCalender([thirtyDaysAgo, dateIT]);
		} else if (dateEvent === "lastyear") {
			setStartDate(startOfYear);
			setEndDate(endOfYear);
			setCalender([startOfYear, endOfYear]);
		} else if (
			dateEvent === "custom" &&
			calender[0] !== "" &&
			calender[1] !== ""
		) {
			setStartDate(calender[0]);
			setEndDate(calender[1]);
		} else {
			return;
		}
	}, [dateEvent, calender[0], calender[1]]);

	// Fetch all data
	const allBusinessData = async () => {
		setLoading(true);
		dispatch(openLoader());
		try {
			const [
				summaryResponse,
				businessResponse,
				failureResponse,
				currencyResponse,
				countryResponse,
				chartResponse,
				cardtypeResponse,
				chargetypeResponse,
				chargebackResponse,
				payoutResponse,
			]: any = await Promise.all([
				axios.get(
					`/v1/trend/transaction/summary?fromdate=${startDate}&todate=${endDate}&search=${currency}`
				),
				axios.get(
					`/v1/trend/top/business?fromdate=${startDate}&todate=${endDate}`
				),
				axios.get(
					`/v1/trend/top/failure?fromdate=${startDate}&todate=${endDate}`
				),
				axios.get(
					`/v1/trend/transaction/chart/currency?fromdate=${startDate}&todate=${endDate}&search=${currency}`
				),
				axios.get(
					`/v1/trend/top/country?fromdate=${startDate}&todate=${endDate}`
				),
				axios.get(
					`/v1/trend/transaction/chart?fromdate=${startDate}&todate=${endDate}&search=${currency}`
				),
				axios.get(
					`/v1/trend/top/cardtype?fromdate=${startDate}&todate=${endDate}`
				),
				axios.get(
					`/v1/trend/top/chargetype?fromdate=${startDate}&todate=${endDate}`
				),
				axios.get(
					`/v1/trend/top/chargeback?fromdate=${startDate}&todate=${endDate}`
				),
				axios.get(
					`/v1/trend/payout/summary?fromdate=${startDate}&todate=${endDate}`
				),
			]);

			setCurrencyDetails(summaryResponse?.data?.data);
			setInfo(summaryResponse?.data?.data[0]);
			setTopBusiness(businessResponse.data.data);
			setTopFailure(failureResponse.data.data);
			setTopCurrency(currencyResponse.data.data);
			setTopCountry(countryResponse.data.data);
			setTopTransaction(chartResponse.data.data);
			setTopCardType(cardtypeResponse.data.data);
			setTopChargeType(chargetypeResponse.data.data);
			setTopChargeBack(chargebackResponse.data.data);
			setPayout(payoutResponse.data.data);

			setLoading(false);
			dispatch(closeLoader());
		} catch (error: any) {
			setLoading(false);
			dispatch(closeLoader());
		}
	};

	// useEffect(() => {
	// 	allBusinessData();
	// }, []);

	//fetch top transactions trend
	// const trendTransaction = () => {
	// 	setLoading(true);
	// 	dispatch(openLoader());
	// 	axios
	// 		.get(
	// 			`/v1/trend/transaction/summary?fromdate=${startDate}&todate=${endDate}&search=${currency}`
	// 		)
	// 		.then((res: any) => {
	// 			setCurrencyDetails(res?.data?.data);
	// 			setInfo(res?.data?.data[0]);
	// 			setLoading(false);
	// 			dispatch(closeLoader());
	// 		})
	// 		.catch((err) => {
	// 			setLoading(false);
	// 			dispatch(closeLoader());

	// 			dispatch(
	// 				openToastAndSetContent({
	// 					toastContent:
	// 						err.response?.data?.message ||
	// 						err?.data?.message ||
	// 						err?.message ||
	// 						err,
	// 					toastType: "error",
	// 				})
	// 			);
	// 		});
	// };
	// fetch top businesses
	// const topBusinessFn = () => {
	// 	dispatch(openLoader());
	// 	axios
	// 		.get(`/v1/trend/top/business?fromdate=${startDate}&todate=${endDate}`)
	// 		.then((res: any) => {
	// 			setTopBusiness(res?.data?.data);
	// 			dispatch(closeLoader());
	// 		})
	// 		.catch((err) => {
	// 			dispatch(closeLoader());
	// 			dispatch(
	// 				openToastAndSetContent({
	// 					toastContent:
	// 						err.response?.data?.message ||
	// 						err?.data?.message ||
	// 						err?.message ||
	// 						err,
	// 					toastType: "error",
	// 				})
	// 			);
	// 		});
	// };
	// fetch top failures
	// const topFailureFn = () => {
	// 	dispatch(openLoader());
	// 	axios
	// 		.get(`/v1/trend/top/failure?fromdate=${startDate}&todate=${endDate}`)
	// 		.then((res: any) => {
	// 			dispatch(closeLoader());
	// 			setTopFailure(res?.data?.data);
	// 		})
	// 		.catch((err) => {
	// 			dispatch(closeLoader());
	// 			dispatch(
	// 				openToastAndSetContent({
	// 					toastContent:
	// 						err.response?.data?.message ||
	// 						err?.data?.message ||
	// 						err?.message ||
	// 						err,
	// 					toastType: "error",
	// 				})
	// 			);
	// 		});
	// };
	// fetch top currencies
	// const topCurrencyFn = () => {
	// 	dispatch(openLoader());
	// 	axios
	// 		.get(
	// 			`/v1/trend/transaction/chart/currency?fromdate=${startDate}&todate=${endDate}&search=${currency}`
	// 		)
	// 		.then((res: any) => {
	// 			dispatch(closeLoader());
	// 			setTopCurrency(res?.data?.data);
	// 		})
	// 		.catch((err) => {
	// 			dispatch(closeLoader());
	// 			dispatch(
	// 				openToastAndSetContent({
	// 					toastContent:
	// 						err.response?.data?.message ||
	// 						err?.data?.message ||
	// 						err?.message ||
	// 						err,
	// 					toastType: "error",
	// 				})
	// 			);
	// 		});
	// };
	// fetch top country
	// const topCountryFn = () => {
	// 	dispatch(openLoader());
	// 	axios
	// 		.get(`/v1/trend/top/country?fromdate=${startDate}&todate=${endDate}`)
	// 		.then((res: any) => {
	// 			dispatch(closeLoader());
	// 			setTopCountry(res?.data?.data);
	// 		})
	// 		.catch((err) => {
	// 			dispatch(closeLoader());

	// 			dispatch(
	// 				openToastAndSetContent({
	// 					toastContent:
	// 						err.response?.data?.message ||
	// 						err?.data?.message ||
	// 						err?.message ||
	// 						err,
	// 					toastType: "error",
	// 				})
	// 			);
	// 		});
	// };
	// fetch top transactions
	// const topTransactionFn = () => {
	// 	dispatch(openLoader());
	// 	axios
	// 		.get(
	// 			`/v1/trend/transaction/chart?fromdate=${startDate}&todate=${endDate}&search=${currency}`
	// 		)
	// 		.then((res: any) => {
	// 			dispatch(closeLoader());
	// 			setTopTransaction(res?.data?.data);
	// 		})
	// 		.catch((err) => {
	// 			dispatch(closeLoader());

	// 			dispatch(
	// 				openToastAndSetContent({
	// 					toastContent:
	// 						err.response?.data?.message ||
	// 						err?.data?.message ||
	// 						err?.message ||
	// 						err,
	// 					toastType: "error",
	// 				})
	// 			);
	// 		});
	// };
	// fetch top card types
	// const topCardTypeFn = () => {
	// 	dispatch(openLoader());
	// 	axios
	// 		.get(`/v1/trend/top/cardtype?fromdate=${startDate}&todate=${endDate}`)
	// 		.then((res: any) => {
	// 			dispatch(closeLoader());
	// 			setTopCardType(res?.data?.data);
	// 		})
	// 		.catch((err) => {
	// 			dispatch(closeLoader());

	// 			dispatch(
	// 				openToastAndSetContent({
	// 					toastContent:
	// 						err.response?.data?.message ||
	// 						err?.data?.message ||
	// 						err?.message ||
	// 						err,
	// 					toastType: "error",
	// 				})
	// 			);
	// 		});
	// };
	// fetch top charge types
	// const topChargeTypeFn = () => {
	// 	dispatch(openLoader());
	// 	axios
	// 		.get(`/v1/trend/top/chargetype?fromdate=${startDate}&todate=${endDate}`)
	// 		.then((res: any) => {
	// 			dispatch(closeLoader());
	// 			setTopChargeType(res?.data?.data);
	// 		})
	// 		.catch((err) => {
	// 			dispatch(closeLoader());

	// 			dispatch(
	// 				openToastAndSetContent({
	// 					toastContent:
	// 						err.response?.data?.message ||
	// 						err?.data?.message ||
	// 						err?.message ||
	// 						err,
	// 					toastType: "error",
	// 				})
	// 			);
	// 		});
	// };
	// fetch top chargebacks
	// const topChargeBackFn = () => {
	// 	dispatch(openLoader());
	// 	axios
	// 		.get(`/v1/trend/top/chargeback?fromdate=${startDate}&todate=${endDate}`)
	// 		.then((res: any) => {
	// 			dispatch(closeLoader());
	// 			setTopChargeBack(res?.data?.data);
	// 		})
	// 		.catch((err) => {
	// 			dispatch(closeLoader());

	// 			dispatch(
	// 				openToastAndSetContent({
	// 					toastContent:
	// 						err.response?.data?.message ||
	// 						err?.data?.message ||
	// 						err?.message ||
	// 						err,
	// 					toastType: "error",
	// 				})
	// 			);
	// 		});
	// };

	// fetch payout
	// const fetchPayout = () => {
	// 	dispatch(openLoader());
	// 	axios
	// 		.get(`/v1/trend/payout/summary?fromdate=${startDate}&todate=${endDate}`)
	// 		.then((res: any) => {
	// 			dispatch(closeLoader());
	// 			setPayout(res?.data?.data);
	// 		})
	// 		.catch((err) => {
	// 			dispatch(closeLoader());
	// 			dispatch(
	// 				openToastAndSetContent({
	// 					toastContent:
	// 						err.response?.data?.message ||
	// 						err?.data?.message ||
	// 						err?.message ||
	// 						err,
	// 					toastType: "error",
	// 				})
	// 			);
	// 		});
	// };

	const getCurrencies = () => {
		let currArr: string[] = [];
		currencyDetails.map(({ currency }) => {
			currArr.push(currency);
		});
		return currArr;
	};

	const TransactionCard = ({
		amount,
		header,
		icon,
		backgroundColor,
		count,
	}: any) => {
		return (
			<div className={styles.transactionCard}>
				<div className={styles.iconSection}>
					<img
						src={icon}
						style={{
							background: backgroundColor,
							borderRadius: "50%",
							padding: "9px",
						}}
					/>
					<span className={styles.total}>{header}</span>
				</div>
				<div className={styles.amount}>{amount || 0}</div>
				<div
					style={{
						display: "flex",
						flexDirection: "row",
						alignItems: "center",
						justifyContent: "space-between",
					}}
				>
					<span className={styles.timeline}>
						{dateEvent === "today"
							? "Today"
							: dateEvent === "last7days"
							? "In the last 7 days"
							: dateEvent === "last30days"
							? "In the last 30 days"
							: dateEvent === "lastyear"
							? "In the last year"
							: "Custom Date Range"}
					</span>
					<span className={styles.count}>{count}</span>
				</div>
			</div>
		);
	};

	useEffect(() => {
		setSelectedInfo(currency);
	}, [currency]);

	useEffect(() => {
		// trendTransaction();
		// topBusinessFn();
		// topFailureFn();
		// topCurrencyFn();
		// topCountryFn();
		// topTransactionFn();
		// topCardTypeFn();
		// topChargeTypeFn();
		// topChargeBackFn();
		// fetchPayout();
		allBusinessData();
	}, [startDate, endDate]);
	// calender

	useEffect(() => {
		if (currencyDetails && currencyDetails.length > 1) {
			let currDetails = currencyDetails.find(
				(item) => item.currency === currency
			);
			if (currDetails) {
				setInfo(currDetails);
			}
		}
	}, [currency]);

	if (loading) {
		return <div></div>;
	}

	return (
		<div className={styles.wrapper}>
			<NavBar name="Overview" />
			<BarTopFilterDate
				setDateEvent={setDateEvent}
				fromDate={startDate}
				toDate={endDate}
				dateEvent={dateEvent}
				calender={calender}
				setCalender={setCalender}
				showMenu={false}
				currency={currency}
				currenciesData={getCurrencies()}
				setCurrency={setCurrency}
			/>
			<div
				style={{
					padding: "30px 24px 10px 24px",
				}}
			>
				<h3 style={{ marginBottom: "10px" }}>Collections</h3>
				<Grid container spacing={1}>
					<Grid item xs={12} sm={6} md={3} lg={3}>
						<TransactionCard
							amount={
								info &&
								`${info?.currency} ${
									(info?.total && numberWithCommas(info?.total)) || 0
								}`
							}
							header="Total Transactions"
							icon={TotalIcon}
							backgroundColor="rgba(98, 184, 228, 0.15)"
							count={(info && info?.total_count) || 0}
						/>
					</Grid>
					<Grid item xs={12} sm={6} md={3} lg={3}>
						<TransactionCard
							amount={
								info &&
								`${info?.currency}
                  ${(info?.success && numberWithCommas(info?.success)) || 0}`
							}
							header="Successful Transactions"
							icon={ReportIcon}
							backgroundColor="rgba(22, 163, 63, 0.15)"
							count={(info && info?.success_count) || 0}
						/>
					</Grid>
					<Grid item xs={12} sm={6} md={3} lg={3}>
						<TransactionCard
							amount={
								info &&
								`${info?.currency} ${numberWithCommas(info?.failed) || 0}`
							}
							header="Failed Transactions"
							icon={FailedIcon}
							backgroundColor="rgba(235, 87, 87, 0.15)"
							count={(info && info?.failed_count) || 0}
						/>
					</Grid>
					<Grid item xs={12} sm={6} md={3} lg={3}>
						<TransactionCard
							amount={
								info &&
								`${info?.currency} ${numberWithCommas(info?.pending || 0)}`
							}
							header="Pending Transactions"
							icon={PendingIcon}
							backgroundColor="rgba(232, 187, 0, 0.15)"
							count={(info && info?.pending_count) || 0}
						/>
					</Grid>
				</Grid>
			</div>

			<div
				style={{
					padding: "10px 24px 30px 24px",
				}}
			>
				<h3 style={{ marginBottom: "10px" }}>Payouts</h3>
				<Grid container spacing={1}>
					<Grid item xs={12} sm={6} md={3} lg={3}>
						<TransactionCard
							amount={
								payout?.length > 0 &&
								`${payout[0]?.currency} ${
									numberWithCommas(payout[0]?.total) || 0
								}`
							}
							header="Total Count"
							icon={TotalIcon}
							backgroundColor="rgba(98, 184, 228, 0.15)"
							count={(payout?.length > 0 && payout[0]?.total_count) || 0}
						/>
					</Grid>
					<Grid item xs={12} sm={6} md={3} lg={3}>
						<TransactionCard
							amount={
								payout?.length > 0 &&
								`${payout[0]?.currency} ${
									numberWithCommas(payout[0]?.success) || 0
								}`
							}
							header="Successful Count"
							icon={ReportIcon}
							backgroundColor="rgba(22, 163, 63, 0.15)"
							count={(payout?.length > 0 && payout[0]?.success_count) || 0}
						/>
					</Grid>
					<Grid item xs={12} sm={6} md={3} lg={3}>
						<TransactionCard
							amount={
								payout?.length > 0 &&
								`${payout[0]?.currency} ${
									numberWithCommas(payout[0]?.failed) || 0
								}`
							}
							header="Failed Count"
							icon={FailedIcon}
							backgroundColor="rgba(235, 87, 87, 0.15)"
							count={(payout?.length > 0 && payout[0]?.failed_count) || 0}
						/>
					</Grid>
					<Grid item xs={12} sm={6} md={3} lg={3}>
						<TransactionCard
							amount={
								payout?.length > 0 &&
								`${payout[0]?.currency} ${
									numberWithCommas(payout[0]?.pending) || 0
								}`
							}
							header="Pending Count"
							icon={PendingIcon}
							backgroundColor="rgba(232, 187, 0, 0.15)"
							count={(payout?.length > 0 && payout[0]?.pending_count) || 0}
						/>
					</Grid>
				</Grid>
			</div>
			<div
				style={{
					padding: "0 24px",
				}}
			>
				<Grid container spacing={2}>
					<Grid item xs={12} md={6}>
						<OverviewTable title="Transactions Chart">
							{topTransaction?.length > 0 ? (
								<TransactionBarChart data={topTransaction} identifier="date" />
							) : (
								<p
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										height: "100%",
										fontWeight: "bold",
									}}
								>
									No Data Found
								</p>
							)}
						</OverviewTable>
					</Grid>
					<Grid item xs={12} md={6}>
						<OverviewTable
							title="Top Countries"
							route={"/utility/countrylist"}
							path={"View wealth analysis"}
						>
							{topCountry.length > 0 ? (
								<PolarAreaChart data={topCountry} />
							) : (
								<p
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										height: "100%",
										fontWeight: "bold",
									}}
								>
									No Data Found
								</p>
							)}
						</OverviewTable>
					</Grid>

					<Grid item xs={12} md={6}>
						<OverviewTable
							title="Top Transacting Businesses"
							path="View businesses"
							route="/businesses"
						>
							<DashboardProductTable data={topBusiness} />
						</OverviewTable>
					</Grid>
					<Grid item xs={12} md={6}>
						<OverviewTable
							title="Transaction Currency Chart"
							path="See all Transactions"
							route="/transactionmgt"
						>
							{topCurrency.length > 0 ? (
								<SimpleBarChart data={topCurrency[0]?.data} identifier="date" />
							) : (
								// <PieChart data={topCurrency} />
								<p
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										height: "100%",
										fontWeight: "bold",
									}}
								>
									No Data Found
								</p>
							)}
						</OverviewTable>
					</Grid>
					<Grid item xs={12} md={6}>
						<OverviewTable title="Performance of the Different Channels/Chargetypes">
							{topChargeType.length > 0 ? (
								<SimpleBarChart data={topChargeType} identifier="chargetype" />
							) : (
								<p
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										height: "100%",
										fontWeight: "bold",
									}}
								>
									No Data Found
								</p>
							)}
						</OverviewTable>
					</Grid>
					<Grid item xs={12} md={6}>
						<OverviewTable
							title="Top Chargebacks By Businesses"
							path="View chargebacks"
							route="/transactionmgt/chargebackmgt"
						>
							{topChargeType.length > 0 ? (
								<ChargeBackChart data={topChargeBack} />
							) : (
								<p
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										height: "100%",
										fontWeight: "bold",
									}}
								>
									No Data Found
								</p>
							)}
						</OverviewTable>
					</Grid>
					<Grid item xs={12} md={6}>
						<OverviewTable title="Card Type Performance">
							{topCardType.length > 0 ? (
								<SimpleBarChart data={topCardType} identifier="cardtype" />
							) : (
								<p
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										height: "100%",
										fontWeight: "bold",
									}}
								>
									No Data Found
								</p>
							)}
						</OverviewTable>
					</Grid>
					<Grid item xs={12} md={6}>
						<OverviewTable
							title="Top Failures"
							path="View More"
							route="/transactionmgt"
						>
							{topFailure?.length > 0 ? (
								<OverviewFailureTable data={topFailure} />
							) : (
								<p
									style={{
										display: "flex",
										justifyContent: "center",
										alignItems: "center",
										height: "100%",
										fontWeight: "bold",
									}}
								>
									No Data Found
								</p>
							)}
						</OverviewTable>
					</Grid>
				</Grid>
			</div>
		</div>
	);
};

export default AdminOverview;
